"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Countdown = /** @class */ (function () {
    function Countdown(endTime) {
        this.endTime = 0;
        this.endTime = endTime;
    }
    Countdown.prototype.startCountdown = function (callBack) {
        var _this = this;
        this.stopCountdown();
        if (this.endTime <= 0)
            return;
        this.activityTimer = setInterval(function () {
            var nowDate = new Date().valueOf();
            if (nowDate < _this.endTime) {
                var time = Math.round((_this.endTime - nowDate) / 1000) * 1000;
                callBack(time);
            }
            else {
                _this.stopCountdown();
            }
        }, 1000);
    };
    Countdown.prototype.stopCountdown = function () {
        clearInterval(this.activityTimer);
    };
    return Countdown;
}());
exports.Countdown = Countdown;
//# sourceMappingURL=countdown.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/utils/countdown.js
// module id = 1047
// module chunks = 0